export default __webpack_public_path__ + "static/media/userIconWhite.1c7d314a.svg";